(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9730],{

/***/ 69730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v1_NewsLetterSignUpOverlay; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(46394);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./components/NewsLetterSignUpOverlay/v1/index.module.scss
var index_module = __webpack_require__(87628);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/SuccessMessage.jsx



const SuccessMessage = (param)=>{
    let { confirmationTitle , confirmationDescription , closeModal , promoCode , copyCtaText , copiedCtaText , isGiftCodeEnable  } = param;
    const [copySuccess, setCopySuccess] = (0,react.useState)(copyCtaText);
    const copyToClipBoard = async (copyMe)=>{
        try {
            await navigator.clipboard.writeText(copyMe);
            setCopySuccess(copiedCtaText);
        } catch (err) {
            setCopySuccess("Failed to copy!");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "news-letter-sign-up__success-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "news-letter-sign-up__thanks",
                children: confirmationTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "news-letter-sign-up__success",
                children: confirmationDescription
            }),
            isGiftCodeEnable && promoCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "copy-code-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "copy-code-number",
                        children: promoCode
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "copy-code-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            label: copySuccess,
                            type: "primary",
                            onClick: ()=>copyToClipBoard(promoCode)
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "success-modal-button",
                parentClass: "parent-wrap",
                label: "Continue Shopping",
                size: "small",
                type: "primary",
                flexible: true,
                role: "button",
                onClick: closeModal
            })
        ]
    });
};
/* harmony default export */ var v1_SuccessMessage = (SuccessMessage);

;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/analytics.js

const getPageType = ()=>{
    const page = (0,helper/* getPageInfo */.UMn)();
    const { category: { pageType =""  }  } = page;
    return pageType;
};
const addAnalyticsForNewsletterSignupOverlay = ()=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "newsletter signup overlay",
        eventMsg: "n/a",
        eventName: "newsletter signup overlay",
        eventStatus: "n/a",
        eventType: "popup",
        internalLinkName: "newsletter signup",
        internalLinkPosition: "newsletter signup",
        internalLinkType: "newsletter signup overlay",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":newsletter signup overlay")
    };
    addAnalyticsForNewsletterSignup(eventInfo, "cmp:show");
};
const addAnalyticsForNewsletterSignupBtn = function(eventStatus) {
    let eventMsg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a";
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "newsletter signup",
        eventMsg,
        eventName: "newsletter signup",
        eventStatus,
        eventType: "click",
        internalLinkName: "sign up",
        internalLinkPosition: "newsletter signup",
        internalLinkType: "newsletter signup overlay:submit",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":newsletter signup overlay")
    };
    addAnalyticsForNewsletterSignup(eventInfo, "cmp:click");
};
const addAnalyticsForNewsletterSignupLinks = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a";
    const linkName = type === null || type === void 0 ? void 0 : type.toLowerCase();
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: linkName === "close" ? "true" : "false",
        eventAction: "newsletter signup:".concat(linkName),
        eventMsg: "n/a",
        eventName: "newsletter signup:".concat(linkName),
        eventStatus: "n/a",
        eventType: "navigate",
        internalLinkName: linkName,
        internalLinkPosition: "newsletter signup",
        internalLinkType: "newsletter signup overlay:".concat(linkName),
        internalLinkURL: url,
        internalLinkZoneName: "".concat(pageType, ":newsletter signup overlay")
    };
    addAnalyticsForNewsletterSignup(eventInfo, "cmp:click");
};
const getRecaptchaAnalytics = {
    addNoFooterInAttr: true,
    pageTitle: "newsletter signup",
    internalLinkPosition: "newsletter signup",
    internalLinkTypeWithType: "newsletter signup overlay",
    internalLinkZoneName: "newsletter signup overlay"
};
const addAnalyticsForNewsletterSignup = (eventInfo, event)=>{
    const page = (0,helper/* getPageInfo */.UMn)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/NewsLetterForm.jsx




const NewsLetterForm = (param)=>{
    let { setEmail , overlayError , onFormSubmit , ctaLabel , heritageCheckbox ={} , setHeritageCheckbox  } = param;
    (0,react.useEffect)(()=>{
        addAnalyticsForNewsletterSignupOverlay();
    }, []);
    const checkboxChangeHandler = function(e) {
        let label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const { target: { checked =false  } = {}  } = e;
        const modifyHeritageCheckbox = {
            ...heritageCheckbox
        };
        modifyHeritageCheckbox[label] = checked;
        setHeritageCheckbox(modifyHeritageCheckbox);
    };
    const heritageCheckboxKeys = Object.keys(heritageCheckbox) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: (e)=>e.preventDefault(),
        className: "ui form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                onChange: (e)=>setEmail(e.target.value),
                id: "newsletter-overlay-input",
                className: "news-letter-sign-up__email-input",
                type: "text",
                placeholder: "Email Address*"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                id: "overlay-mail-error",
                className: "overlay-mail-errormsg",
                children: overlayError
            }),
            heritageCheckboxKeys.map((item)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "news-letter-sign-up__checkbox1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        value: item,
                        checked: heritageCheckbox[item],
                        onChange: (e)=>checkboxChangeHandler(e, item)
                    })
                }, item);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "news-letter-sign-up__button",
                type: "button",
                onClick: onFormSubmit,
                value: ctaLabel
            })
        ]
    });
};
/* harmony default export */ var v1_NewsLetterForm = (NewsLetterForm);

// EXTERNAL MODULE: ./node_modules/react-activity-detector/lib/ActivityDetector.js
var ActivityDetector = __webpack_require__(31166);
var ActivityDetector_default = /*#__PURE__*/__webpack_require__.n(ActivityDetector);
;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/NewsLetterSignUpOverlay.jsx















const NewsLetterSignUpOverlay = (param)=>{
    let { data , showCampaign =false , handleModalClose  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticContent = (data === null || data === void 0 ? void 0 : data.content) || {};
    const { exceptionalPage =[] , useTimer =0 , copyCtaText ="" , copiedCtaText ="" , promoCode ="" , usedForCampaign =false , formTitle ="" , formDescription ="" , confirmationTitle ="" , confirmationDescription ="" , ctaLabel ="" , ctaCheckboxParameters =[] , apiEventType ="" , endpointUrl ="" , bodyParameters ={}  } = staticContent;
    const i18n = {
        privacyPolicy: t("kf.associatemembership.label.privacyPolicy"),
        subjectAccessRequest: t("kf.associatemembership.label.subjectAccessRequest"),
        termsOfService: t("kf.associatemembership.label.termsOfService")
    };
    const [config, setConfig] = (0,react.useState)({});
    const [email, setEmail] = (0,react.useState)("");
    const [showModal, setShowModal] = (0,react.useState)(showCampaign);
    const [idealTime, setIdealTime] = (0,react.useState)(constants.DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME);
    const [heritageCheckbox, setHeritageCheckbox] = (0,react.useState)(ctaCheckboxParameters.reduce((obj, item)=>Object.assign(obj, {
            [item.checkboxLabel]: true
        }), {}));
    const [state, setState] = (0,react.useState)({
        cookieval: true,
        overlayError: "",
        showSuccessModal: false,
        confirmModal: false,
        cookieAccepted: false,
        timeExceeded: false
    });
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            setConfig({
                siteName: get_default()(CONFIG, "general.siteName", ""),
                legalPages: get_default()(CONFIG, "legalPageData.map", {})
            });
        });
        if (usedForCampaign) localStorage.removeItem("isSignedUpForNewsletter");
    }, []);
    (0,react.useEffect)(()=>{
        if (useTimer) {
            setShowModal(true);
            // on page load open the popup based on the timer
            const timer = Number((staticContent === null || staticContent === void 0 ? void 0 : staticContent.timer) || constants.DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME);
            setIdealTime(timer);
        }
    }, [
        staticContent
    ]);
    (0,react.useEffect)(()=>{
        if (showCampaign) setShowModal(showCampaign);
    }, [
        showCampaign
    ]);
    const onFormSubmit = (event)=>{
        event.preventDefault();
        const getEmailval = email;
        if (getEmailval === "") {
            setState({
                ...state,
                overlayError: "Email Address*"
            });
        } else if (!/\S+@\S+\.\S+/.test(getEmailval)) {
            setEmail("");
            setState({
                ...state,
                overlayError: "Enter valid Email Address"
            });
        } else {
            getSubscriptionData();
        }
    };
    const closeModal = ()=>{
        handleNewseletterModalClose();
    };
    const getSubscriptionData = ()=>{
        if (email) {
            let params = {
                brand: config.siteName.toLowerCase()
            };
            let body = {
                keys: {
                    SubscriberKey: email
                },
                values: {
                    ...bodyParameters
                }
            };
            body.values["EmailAddress"] = email;
            body.values["Date Updated"] = new Date().toISOString();
            if (usedForCampaign) {
                const heritageCheckboxPayload = {};
                if (ctaCheckboxParameters.length) {
                    const heritageCheckboxKeys = Object.keys(heritageCheckbox).filter((item)=>heritageCheckbox[item]);
                    const heritageCheckboxes = ctaCheckboxParameters.filter((item)=>heritageCheckboxKeys.includes(item.checkboxLabel));
                    heritageCheckboxes.forEach((item)=>{
                        const heritageCheckboxKeyObj = item.checkboxParameters.reduce((obj, itemObj)=>Object.assign(obj, {
                                [itemObj.checkboxKey]: itemObj.checkboxValue
                            }), {});
                        Object.keys(heritageCheckboxKeyObj).forEach((key)=>{
                            heritageCheckboxPayload[key] = heritageCheckboxKeyObj[key];
                        });
                    });
                }
                body = {
                    email,
                    ...heritageCheckboxPayload
                };
                params = {
                    event: apiEventType
                };
            }
            const requestPayload = usedForCampaign ? body : [
                body
            ];
            api/* apim.post */.TH.post(endpointUrl, requestPayload, {
                params
            }).then((response)=>{
                if (response && response.data) {
                    setState({
                        ...state,
                        confirmModal: true
                    });
                    if (!usedForCampaign) localStorage.setItem("isSignedUpForNewsletter", "true");
                    addAnalyticsForNewsletterSignupBtn("success");
                } else {
                    addAnalyticsForNewsletterSignupBtn("failure", email);
                    console.error("News letter subscription API: Error occured while fetching data from Get URL Property");
                }
            }, (errObj)=>{
                const { data: { message  }  } = errObj.response;
                const { data: { error  }  } = errObj.response;
                addAnalyticsForNewsletterSignupBtn("failure", email);
                setState({
                    ...state,
                    overlayError: message || error
                });
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (state.cookieAccepted) {
            localStorage.setItem(constants.PRIVACY_COOKIE_CLICKED, state.cookieAccepted);
        }
    }, [
        state.cookieAccepted
    ]);
    const handleNewseletterModalClose = ()=>{
        setShowModal(false);
        setState({
            ...state,
            confirmModal: false
        });
        if (useTimer) localStorage.setItem("isSignedUpForNewsletter", "true");
        handleModalClose();
        (0,helper/* preventBodyScroll */.MVu)(false);
        addAnalyticsForNewsletterSignupLinks("close", "n/a");
    };
    (0,react.useEffect)(()=>{
        if (!isDataEditorMode && !isSignedUpForNewsletter && timeExceeded && isDisplay === false) {
            (0,helper/* preventBodyScroll */.MVu)(true);
        }
    }, [
        state.timeExceeded
    ]);
    const onIdle = ()=>{
        setState({
            ...state,
            timeExceeded: true
        });
    };
    const { confirmModal , timeExceeded , overlayError  } = state;
    const isDisplay = exceptionalPage && exceptionalPage.length && exceptionalPage.some((page)=>page.exceptionalPageName === window.location.pathname);
    const isSubscribe = !!localStorage.getItem("isSignedUpForNewsletter");
    const isSignedUpForNewsletter = isSubscribe && !confirmModal;
    const isDataEditorMode = document.body.hasAttribute("data-editor-mode");
    const isModalVisibleBasedOnTimer = !isDataEditorMode && !isSignedUpForNewsletter && timeExceeded && isDisplay === false;
    const showNewsletterModal = useTimer ? isModalVisibleBasedOnTimer : !isSignedUpForNewsletter && showModal;
    const { legalPages: { privacyPolicy ="n/a" , subjectAccessRequest ="n/a" , termsOfService ="n/a"  } = {}  } = config;
    const { privacyPolicy: privacyPolicyText = "" , subjectAccessRequest: subjectAccessRequestText = "" , termsOfService: termsOfServiceText = ""  } = i18n;
    const handleClickOfLinks = (text, url)=>{
        window.open(url);
        addAnalyticsForNewsletterSignupLinks(text, url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).signupModalwrapper,
        children: [
            useTimer ? /*#__PURE__*/ (0,jsx_runtime.jsx)((ActivityDetector_default()), {
                activityEvents: constants.customActivityEvents,
                enabled: !isSignedUpForNewsletter,
                timeout: idealTime * 1000,
                onIdle: onIdle,
                name: "newsletterSignupModalActivityDetector"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "news-letter-sign-up",
                children: showNewsletterModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    showModal: showModal,
                    onModalClose: handleNewseletterModalClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "news-letter-sign-up__newsletter-overlay",
                        children: [
                            !confirmModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "news-letter-sign-up__content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "news-letter-sign-up__header",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(formTitle)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "news-letter-sign-up__subcopy",
                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(formDescription)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_NewsLetterForm, {
                                        setEmail: setEmail,
                                        overlayError: overlayError,
                                        onFormSubmit: onFormSubmit,
                                        ctaLabel: ctaLabel,
                                        heritageCheckbox: heritageCheckbox,
                                        setHeritageCheckbox: setHeritageCheckbox
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                        getAnalyticsData: getRecaptchaAnalytics,
                                        isPopupNeededBeforeRedirection: false
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "news-letter-sign-up__policies",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>handleClickOfLinks(privacyPolicyText, privacyPolicy),
                                                role: "link",
                                                children: privacyPolicyText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>handleClickOfLinks(subjectAccessRequestText, subjectAccessRequest),
                                                children: subjectAccessRequestText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>handleClickOfLinks(termsOfServiceText, termsOfService),
                                                children: termsOfServiceText
                                            })
                                        ]
                                    })
                                ]
                            }),
                            confirmModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SuccessMessage, {
                                confirmationTitle: confirmationTitle,
                                confirmationDescription: confirmationDescription,
                                closeModal: closeModal,
                                promoCode: promoCode,
                                copyCtaText: copyCtaText,
                                copiedCtaText: copiedCtaText,
                                isGiftCodeEnable: usedForCampaign
                            })
                        ]
                    })
                }) : null
            })
        ]
    });
};
/* harmony default export */ var v1_NewsLetterSignUpOverlay = (NewsLetterSignUpOverlay);


/***/ }),

/***/ 87628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signupModalwrapper":"v1_signupModalwrapper__Zuhat"};

/***/ }),

/***/ 31166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{"use strict";var e={d:(t,o)=>{for(var r in o)e.o(o,r)&&!e.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:o[r]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};e.r(t),e.d(t,{default:()=>l});const o=__webpack_require__(67294),r=["click","mousemove","keydown","DOMMouseScroll","mousewheel","mousedown","touchstart","touchmove","focus"],n="React_Activity_Detector_Idle_Timer",a=()=>(new Date).getTime();let i={},c={};const l=e=>{const{activityEvents:t,timeout:l,enabled:u,onIdle:s,onActive:d,name:m}={activityEvents:r,timeout:3e5,enabled:!1,name:"default",...e},[v,f]=(0,o.useState)(!1),w=e=>{clearTimeout(i[m]),i[m]=setTimeout((()=>{const e=(e=>localStorage.getItem(n+"-"+e))(m);a()>=e&&s&&s()}),e)},y=()=>{clearTimeout(c[m]),c[m]=setTimeout((()=>f(!1)),200),d&&d()},g=({key:e,newValue:t})=>{e===n+"-"+m&&w(t-a())};return(0,o.useEffect)((()=>(u&&(t.forEach((e=>window.addEventListener(e,y))),window.addEventListener("storage",g),f(!1)),()=>{t.forEach((e=>window.removeEventListener(e,y))),window.removeEventListener("storage",g),clearTimeout(i[m]),clearTimeout(c[m])})),[u]),(0,o.useEffect)((()=>{v||(w(l),((e,t)=>{localStorage.setItem(n+"-"+t,e)})(a()+l,m)),f(!0)}),[v,l]),v};module.exports=t})();

/***/ })

}]);